var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

import React from "react";
export default ((_ref) => {
  let {
    styles = {}
  } = _ref,
      props = _objectWithoutProperties(_ref, ["styles"]);

  return React.createElement(
    "svg",
    _extends({ xmlns: "http://www.w3.org/2000/svg", width: "40", height: "40", viewBox: "0 0 40 40" }, props),
    React.createElement(
      "g",
      { fill: "none", fillRule: "evenodd" },
      React.createElement("rect", { width: "40", height: "40", fill: "#E1F7F7", rx: "8" }),
      React.createElement("path", { d: "M8 8h24v24H8z" }),
      React.createElement("path", { fill: "#018489", d: "M12 11h16a1 1 0 0 1 .117 1.993L28 13h-2v3h1a2 2 0 0 1 2 2v6a2 2 0 0 1-2 2H17a2 2 0 0 1-2-2v-6a2 2 0 0 1 2-2h1v-3h-5v15a1 1 0 0 1-1.993.117L11 28V12a1 1 0 0 1 .883-.993L12 11h16-16zm15 7H17v6h10v-6zm-3-5h-4v3h4v-3z" })
    )
  );
});